import React from "react";
import { WebSite, WithContext } from "schema-dts";

import { JSONLDComponent } from "../JSONLDComponent";

export const WebSiteSchema: React.FC = () => {
  const webSiteData: WithContext<WebSite> = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "EquipmentShare",
    url: window.location.origin,
  };

  // Return if the current page is not homepage
  if (window.location.pathname !== "/") {
    return null;
  }

  return <JSONLDComponent structuredData={webSiteData} />;
};
